var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React from 'react';
import { observer } from 'mobx-react';
let MenubarProgressBarState = class MenubarProgressBarState extends React.PureComponent {
    get totalNumber() {
        return this.props.app.funnel.funnelIncoming.miniQuestionsFiltered.length;
    }
    get thisStateNumber() {
        return this.props.app.funnel.funnelIncoming.miniQuestionsFiltered.filter(mini => mini.miniPassState.questionState === this.props.questionstate.id).length;
    }
    render() {
        const { questionstate } = this.props;
        return (React.createElement("div", { className: `progress-bar${questionstate.color ? ` progress-bar-${questionstate.color}` : undefined}`, style: { width: `${Math.round(this.thisStateNumber / this.totalNumber)}%` } },
            React.createElement("span", { className: "sr-only" })));
    }
};
MenubarProgressBarState = __decorate([
    observer
], MenubarProgressBarState);
export { MenubarProgressBarState };
//  <AvailableTooltip placement="bottom" title={questionstate.name} key={questionstate.id}>  </AvailableTooltip>
